import React from 'react';
import {InterestItem} from './InterestItem';
import {ScreenInterest} from '../screens/TagSelectionScreen';

export type CategoryWithTagsProps = {
  categoryName: string;
  categoryInterests: ScreenInterest[];
  selectedInterests: ScreenInterest[];
  toggleInterest: (interest: ScreenInterest) => void;
};

export const CategoryWithTags = ({
  categoryName,
  categoryInterests,
  toggleInterest,
  selectedInterests,
  // handleCategoryToggle,
}: CategoryWithTagsProps) => {
  const categoryContainerStyle: React.CSSProperties = {
    marginBottom: '48px',
    width: '100%',
  };

  const headerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '15px',
    borderBottom: '1px solid #333',
    paddingBottom: '10px',
  };

  const categoryTitleStyle: React.CSSProperties = {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#ffffff',
    margin: 0,
  };

  const interestsGridStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    paddingTop: '10px',
  };

  return (
    <div style={categoryContainerStyle}>
      <div style={headerStyle}>
        <h1 style={categoryTitleStyle}>{categoryName}</h1>
        {/* <button
          onClick={() => handleCategoryToggle(categoryName)}
          style={selectAllButtonStyle}>
          Select All
        </button> */}
      </div>
      <div style={interestsGridStyle}>
        {categoryInterests.map(interest => (
          <InterestItem
            key={interest.tagCode}
            text={interest.tagName}
            onSelect={() => toggleInterest(interest)}
            isSelected={selectedInterests.some(
              (sel: any) => sel.tagName === interest.tagName,
            )}
          />
        ))}
      </div>
    </div>
  );
};
